window.$ = jQuery;
import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Animation } from './modules/animation.js';
import { default as Buttons } from './modules/buttons.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Filters } from './modules/filters.js';
import { default as Modal } from './modules/modal.js';
import { default as Nav } from './modules/nav.js';
import { default as Sliders } from './modules/sliders.js';
import { default as Tabs } from './modules/tabs.js';
import { default as Video } from './modules/video.js';

const modules = {
  Common,
  Accordion,
  Animation,
  Buttons,
  Collapse,
  Filters,
  Modal,
  Nav,
  Sliders,
  Tabs,
  Video,
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
